module.exports = __webpack_public_path__ + "img/ANONYMOUS_1.jpg";